<template>
  <span>
    <div id="start_overlay">
        <span id="loading_section" v-show="$store.getters['app/loading']">
            <h1 id="loading_text">Aan het laden...
              <br>
              <span v-show="$store.getters['app/percentageLoad'] != null" v-html="$store.getters['app/percentageLoad']"></span>
            </h1>
        </span>

        <!-- App -->
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 29.png">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 29.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 30.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 37.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 60.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 64.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 62.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 65.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 61.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 63.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 29.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">
        <img class="loaders" @load="addLoader()" src="./../assets/images/Asset 51.png" alt="">

        <!-- Also preload videos -->
        <!-- <video id="video_1" loop playsinline>
          <source src="./../assets/background.mp4" type="video/mp4" />
        </video> -->

    </div>
  </span>
</template>

<script>
export default {
  name: "Preload",

  data() {
    return {
      loader: 0
    };
  },

  methods: {
    addLoader() {
      this.loader++;
    }
  },

  watch: {
    loader(loaded) {
      /**
       * Be sure that this is the exact amount of assets to be loaded
       */
      const total_elements = document.getElementsByClassName('loaders').length;

      this.$store.dispatch('app/asyncUpdatePercentageLoad', {
          percentage_load: parseInt( ( loaded / total_elements ) * 100 ) + ' / 100',
      });

      // If critical assets are loaded, show start button
      if ( loaded == total_elements ) {
        this.$store.dispatch('app/asyncUpdateStarted', {
          started: true,
        });
        this.$store.dispatch('app/asyncUpdateLoading', {
          loading: false,
        });
        this.$router.push('/');

        this.$store.dispatch('app/asyncUpdatePercentageLoad', {
          percentage_load: null,
        });
      }
    }
  },
};
</script>

<style>
  #start_overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #b08f6c;
  }

  .loaders {
    display: none;
  }

  #loading_text {
    font-family: 'LuckiestGuy';
    margin-top: 8%;
    width: 100%;
    height: 20%;
    left: 0%;
    color: white;
    font-size: 5vw;
    text-align: center;
    font-size: 4em;
    color: white;
    z-index: 100;
  }

  #loading_section {
    z-index: 100;
    position: fixed;
    width: 100%;
  }
</style>
